var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"MonthEmployee"},[_c('svg-sprite',{attrs:{"width":"20","height":"20","icon-id":_vm.getIcon()}}),_c('div',[_vm._v(_vm._s(_vm.getText()))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }